document.addEventListener('DOMContentLoaded', () => {
  const accordions = Array.from(document.querySelectorAll('.accordion'))
  const panels = Array.from(document.querySelectorAll('.panel'))

  const findPanel = (button, index) => {
    const next = button.nextElementSibling
    if (next && next.classList.contains('panel')) return next

    return panels[index] || null
  }

  const setPanelState = (button, panel, expanded) => {
    button.classList.toggle('active', expanded)
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false')
    panel.style.overflow = 'hidden'
    panel.style.maxHeight = expanded ? `${panel.scrollHeight}px` : '0px'
  }

  accordions.forEach((button, index) => {
    const panel = findPanel(button, index)
    if (!panel) return

    button.setAttribute('role', 'button')
    button.setAttribute('aria-expanded', button.classList.contains('active') ? 'true' : 'false')
    setPanelState(button, panel, button.classList.contains('active'))

    button.addEventListener('click', event => {
      event.preventDefault()
      setPanelState(button, panel, !button.classList.contains('active'))
    })
  })

  if (window.matchMedia('(min-width: 501px)').matches && accordions.length) {
    const firstButton = accordions[0]
    const firstPanel = findPanel(firstButton, 0)

    if (firstPanel && !firstButton.classList.contains('active')) {
      setPanelState(firstButton, firstPanel, true)
    }
  }

  if (!window.Splide) return

  document.querySelectorAll('.splide').forEach(slider => {
    if (slider.classList.contains('is-initialized')) return

    try {
      new Splide(slider).mount()
    } catch (error) {
      console.warn('Splide slider failed to initialize', error)
    }
  })
})
